import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { AppTextField } from '@vyce/core/src/components/inputs';
import { ButtonTitleWithLoading } from '@vyce/core/src/components';
import { FolderColour } from './folderColour';
import { FolderColourSwatches } from './FolderColourSwatches';

interface Props {
  open: boolean;
  folderName: string;
  loading?: boolean;
  onFolderNameChange: (value: string) => void;
  onClose: () => void;
  onCreate: (colour: FolderColour | null) => void | Promise<void>;
}

export const CreateFolderDialog: React.FC<Props> = ({
  open,
  folderName,
  loading = false,
  onFolderNameChange,
  onClose,
  onCreate,
}) => {
  const theme = useTheme();
  const [selectedColour, setSelectedColour] = useState<FolderColour | null>(null);

  useEffect(() => {
    if (open) setSelectedColour(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create folder</DialogTitle>
      <DialogContent>
        <AppTextField
          value={folderName}
          onChange={e => onFolderNameChange(e.target.value)}
          label="Folder name"
          fullWidth
          autoFocus
        />
        <Box marginTop={3}>
          <Typography variant="subtitle2" style={{ marginBottom: 8, color: theme.palette.text.primary }}>
            Colour
          </Typography>
          <FolderColourSwatches currentColour={selectedColour} onSelect={setSelectedColour} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button size="large" variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          size="large"
          style={{ minWidth: 115 }}
          color="primary"
          onClick={() => onCreate(selectedColour)}
          variant="contained"
          disabled={loading}>
          <ButtonTitleWithLoading title="Create" loaderVariant="paper" loading={!!loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
